var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"restaurantSearch",staticClass:"restaurant-search-wrapper"},[_vm._t("input-view",null,{"handler":{
      submitHandler: _vm.submitHandler,
      inputHandler: _vm.inputHandler,
      toggleHiddenSuggestion: _vm.toggleHiddenSuggestion,
      focusHandler: _vm.focusHandler,
    },"meta":{ isLoading: _vm.isLoading, isSuccess: _vm.isSuccess, isAnyResult: _vm.isAnyResult }}),_c('div',[_vm._t("suggestion-view",null,{"keyword":_vm.keyword,"suggestions":{
        restaurantsSuggestions: _vm.restaurantsSuggestions,
        locationsSuggestions: _vm.locationsSuggestions,
        cuisinesSuggestions: _vm.cuisinesSuggestions,
      },"handler":{ toggleHiddenResult: _vm.toggleHiddenResult },"meta":{ isLoading: _vm.isLoading, isSuccess: _vm.isSuccess, isAnyResult: _vm.isAnyResult, isShowSuggestion: _vm.isShowSuggestion }})],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }